import { forwardRef } from 'react'
import { t } from '../i18n.ts'
import './NowMarker.css'

/** The current-time line in the day list. */
export const NowMarker = forwardRef<HTMLLIElement, { time: string }>(function NowMarker(
  { time },
  ref,
) {
  return (
    <li className="now-marker" ref={ref} aria-label={`${t.day.nowAria}: ${time}`}>
      <span className="now-marker__time">{time}</span>
      <span className="now-marker__line" aria-hidden="true" />
      <span className="now-marker__label">{t.day.nowLabel}</span>
    </li>
  )
})
